import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { JwtModule } from '@auth0/angular-jwt';

import { AppComponent } from './app.component';
import { RegisterComponent } from './features/register/register.component';
import { LoginComponent } from './features/login/login.component';
import { LogoutComponent } from './features/logout/logout.component';
import { NotFoundModule } from './shared/not-found/not-found.module';

import { AuthGuardUser } from './core/auth/auth-guard-user.service';
import { AuthGuardLoggedIn } from './core/auth/auth-guard-logged-in.service';
import { AuthGuardClient } from './core/auth/auth-guard-client.service';
import { AuthGuardAdmin } from './core/auth/auth-guard-admin.service';
import { AuthGuardExternalUser } from './core/auth/auth-guard-externalUser.service';
import { AuthGuardSuperAdmin } from './core/auth/auth-guard-superadmin.service';

import { PublicLayoutComponent } from './core/layout/public/public-layout.component';
import { ExternalLayoutComponent } from './core/layout/external/external-layout.component';
import { LayoutComponent } from './core/layout/secure/layouts/normal/layout.component';
import { SearchComponent } from './features/search/search.component';
import { UserRole } from './core/auth/roles.enum';
import { AuthGuardAuthenticated } from './core/auth/auth-guard-authenticated';


const PUBLIC_ROUTES: Routes = [
  { path: 'login', component: LoginComponent, canActivate: [AuthGuardLoggedIn] },
  { path: 'logout', component: LogoutComponent },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
];

const CLIENT_ROUTES: Routes = [
  // { path: 'account', component: AccountComponent },
  { path: 'account', loadChildren: './features/account/account.module#AccountModule' },
  { path: 'not-found', loadChildren: './shared/not-found/not-found.module#NotFoundModule' },
  { path: '', pathMatch: 'full', loadChildren: './features/client/client.module#ClientModule' },
  { path: '**', redirectTo: '/not-found', pathMatch: 'full' }
];

const SECURE_ROUTES: Routes = [
  // { path: '', redirectTo: '/', pathMatch: 'full', },
  { path: 'upload', loadChildren: './features/upload/upload.module#UploadModule', canActivateChild: [AuthGuardAdmin] },
  { path: 'reports', loadChildren: './features/reports/reports.module#ReportsModule', canActivateChild: [AuthGuardUser] },
  { path: 'console', loadChildren: './features/console/console.module#ConsoleModule', canActivateChild: [AuthGuardUser] },
  { path: 'dashboard', loadChildren: './features/dashboard/dashboard.module#DashboardModule', canActivateChild: [AuthGuardUser] },
  { path: 'team', loadChildren: './features/team/team.module#TeamModule', canActivateChild: [AuthGuardUser] },
  { path: 'projects', loadChildren: './features/projects/projects.module#ProjectsModule', canActivateChild: [AuthGuardUser] },
  { path: 'events', loadChildren: './features/events/events.module#EventsModule', canActivateChild: [AuthGuardUser] },
  { path: 'contacts', loadChildren: './features/contacts/contacts.module#ContactsModule' },
  { path: 'companies', loadChildren: './features/companies/companies.module#CompaniesModule' },
  { path: 'ambassadors', loadChildren: './features/ambassadors/ambassadors.module#AmbassadorsModule', canActivateChild: [AuthGuardUser] },
  { path: 'account', loadChildren: './features/account/account.module#AccountModule', canActivateChild: [AuthGuardUser] },
  { path: 'admin', loadChildren: './features/admin/admin.module#AdminModule', canActivateChild: [AuthGuardAdmin] },
  { path: 'ext', loadChildren: './features/external/external.module#ExternalModule', canActivateChild: [AuthGuardExternalUser] },
  { path: 'search', component: SearchComponent, canActivate: [AuthGuardUser] },
  // { path: 'logout', component: LogoutComponent },
  // { path: 'not-found', loadChildren: './shared/not-found/not-found.module#NotFoundModule' },
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  { path: '**', redirectTo: '/not-found', pathMatch: 'full' },
];

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'client', component: ExternalLayoutComponent, data: { title: 'Client Views' }, canActivateChild: [AuthGuardClient], children: CLIENT_ROUTES, },
  // { path: 'ext', component: ExternalLayoutComponent, data: { title: 'External Views' }, canActivateChild: [AuthGuardExternalUser], children: EXTERNAL_ROUTES, },
  { path: '', component: PublicLayoutComponent, data: { title: 'Public Views' }, children: PUBLIC_ROUTES },
  { path: '', component: LayoutComponent, data: { title: 'Secure Views' }, canActivateChild: [AuthGuardAuthenticated], children: SECURE_ROUTES, },
];


@NgModule({
  imports: [
    RouterModule.forRoot(routes,
      // {
      //   enableTracing: true
      // }
    )
  ],
  exports: [
    RouterModule
  ]
})

export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./client/app/app-routing.module.ts